export default "__VITE_ASSET__DLToW9l0__"